import React from 'react';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import {Lightbox} from 'primereact/lightbox';
import servicioTrabajador from '../servicios/ServicioTrabajador';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioExpediente from '../servicios/ServicioTcExpediente';
export class ConsultarArchivosTrabajador extends React.Component {
    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            tcExpediente: {},
            iFrameSrc:null
           
            
        }
        
    }
    componentDidMount() {
        this.obtenerPagina();
    }
    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioExpediente.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }

    columnaVerArchivo = (rowData, column) => {
        return <div>
            <div>            
                <Button icon="pi-md-remove-red-eye" type="button" tooltip="Ver archivo" onClick={(e) => this.visorPdf(column.rowData, 'pdf')}></Button>
            </div>
        </div>;
        
    }
    visorPdf = (objeto, tipo) => {
        servicioArchivo.descargaArchivoComoBlob('/expediente/descarga_archivo_pdf.json?id=' + objeto.id + '&tipo=' + tipo)
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });

    }
    formatoTipoDocumento(rowData, column) {
        let tipo = rowData.tipo;
        let valor = "";
        switch (tipo) {
          case 0:
            valor = "Expediente";
            break;
          case 1:
            valor = "Convenio";
            break;
         
          default:
            valor = "";
        }
        return <div>
          {valor}
        </div>;
      }
    render(){
        let { errores, paginacion, inicio, trabajador, accion,  iFrameSrc } = this.state;
        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );
        return(
            <div className="content-section implementation">
                 <div className="card card-w-title">
                        <h1>Expediente</h1>
                       
                    </div>
                  <Growl ref={(el) => this.growl = el} />
                  <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                    </div>
                </Lightbox>
                 <div className="content-section implementation">
                    <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} resizableColumns={true} responsive={true}>
                        <Column field="nombre" header="Nombre del archivo" />
                        <Column field="tipo" body={this.formatoTipoDocumento} header="Tipo de archivo" />
                        <Column header="Ver Archivo" body={this.columnaVerArchivo}  autoLayout={true}/>
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
                </div>
        )
    }
}